import React, { useState, useEffect } from 'react';
import { Typography } from '@material-ui/core';
import wordsToNumbers from 'words-to-numbers';
import alanBtn from '@alan-ai/alan-sdk-web';

import { NewsCards, Modal } from './components';
import useStyles from './styles';

const App = () => {
 const [activeArticle, setActiveArticle] = useState(0);
 const [newsArticles, setNewsArticles] = useState([]);
 const [isOpen, setIsOpen] = useState(false);

 const classes = useStyles();

 useEffect(() => {
  alanBtn({
   key: '64370f4c903e66c5b517887fefa45c1b2e956eca572e1d8b807a3e2338fdd0dc/stage',
   onCommand: ({ command, articles, number }) => {
    if (command === 'newHeadlines') {
     setNewsArticles(articles);
     setActiveArticle(-1);
    } else if (command === 'instructions') {
     setIsOpen(true);
    } else if (command === 'highlight') {
     setActiveArticle((prevActiveArticle) => prevActiveArticle + 1);
    } else if (command === 'open') {
     const parsedNumber = number.length > 2 ? wordsToNumbers((number), { fuzzy: true }) : number;
     const article = articles[parsedNumber - 1];

     if (parsedNumber > articles.length) {
      alanBtn().playText('Please try that again...');
     } else if (article) {
      window.open(article.url, '_blank');
      alanBtn().playText('Opening...');
     } else {
      alanBtn().playText('Please try that again...');
     }
    }
   },
  });
 }, []);

 return (
  <div>
   <h1 className="title">What's <span className="primary-color bigger">News</span> Alan?</h1>
   <div className={classes.logoContainer}>
    {newsArticles.length ? (
     <div className={classes.infoContainer}>
      <div className={classes.card}><Typography variant="h5" component="h2">Try saying: <br /><br />Open article number [4]</Typography></div>
      <div className={classes.card}><Typography variant="h5" component="h2">Try saying: <br /><br />Go back</Typography></div>
     </div>
    ) : null}

   </div>
   <NewsCards articles={newsArticles} activeArticle={activeArticle} />
   <Modal isOpen={isOpen} setIsOpen={setIsOpen} />
  </div>
 );
};

export default App;
